module.exports = __webpack_public_path__ + "img/nlic_main0.a7abee13.jpg";